import { useFormikContext } from 'formik'

import { useCommonSubmitBPayTransfer } from 'pages/Transfer/hooks/useSendBpayTransfer/useCommonSubmitBPayTransfer'
import { useTransferState } from 'pages/Transfer/Transfer.context'
import { TransferEvent } from 'pages/Transfer/Transfer.stateMachine'
import { TransferBpayFields } from 'pages/Transfer/Transfer.types'
import { StyledNextButton } from 'components/Buttons/ActionButtonsGroup/ActionButtonsGroup.styled'
import { shared } from 'translations'

export const TransferBpaySubmitButton = () => {
  const {
    transferState: [, send],
  } = useTransferState()

  const { values } = useFormikContext<TransferBpayFields>()
  const { handleClick, isDisabled, isLoading } = useCommonSubmitBPayTransfer({
    values,
    onSuccess: () => {
      send(TransferEvent.Continue)
    },
    onError: () => {
      send(TransferEvent.Error)
    },
  })

  return (
    <StyledNextButton
      onClick={() => {
        send(TransferEvent.Continue)
        handleClick()
      }}
      isLoading={isLoading}
      disabled={isDisabled}
    >
      {shared.pay}
    </StyledNextButton>
  )
}
